// extracted by mini-css-extract-plugin
module.exports = {"pinned-highlight-card":"styles__pinned-highlight-card___egHRh"};